import { vuex as login } from './login'
import { vuex as dashboard } from './dashboard'
import { vuex as assessment } from './assessment'
import { vuex as stream } from './stream'
import { vuex as explore } from './explore'
import { vuex as programguide } from './programguide'
import { vuex as career } from './career'
import { vuex as job } from './job'
import { vuex as employer } from './employer'

export default { login, dashboard, assessment, stream, explore, programguide, career, job, employer }



// WEBPACK FOOTER //
// ./src/app/vuex.js